import {
  Button,
  Flex,
  Heading,
  Loading,
  showAlertModalError,
} from '@conteg/ui';
import Error from 'components/error/error';
import Notification from 'components/notification/notification';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  StorageUnitDocument,
  StorageUnitsDocument,
  useTerminateReservationMutation,
} from 'types/generated/graphql';
import { resolveTwoFactorErrorKey } from 'utils/errors/resolve-two-factor-error-key';
import { useInvalidateQueries } from 'utils/hooks/use-ivalidate-queries';
import { appRoutes } from 'utils/routing/routes';

const TerminateReservation = ({ reservationId }: { reservationId: string }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const invalidate = useInvalidateQueries();
  const [formNotice, setFormNotice] = useState<string>('');

  const {
    mutate: terminateReservation,
    isPending,
    error,
  } = useTerminateReservationMutation();

  const handleTerminateAllocation = () => {
    setFormNotice('');
    terminateReservation(
      {
        reservationId,
      },
      {
        onSuccess: () => {
          invalidate([StorageUnitDocument, StorageUnitsDocument]);
          alert(t('Page.StorageUnit.Actions.Terminate.Reservation.Success'));
          navigate(appRoutes.home);
        },
        onError: (error) =>
          showAlertModalError(
            t(
              resolveTwoFactorErrorKey(
                error,
                'Page.StorageUnit.Actions.Terminate.Reservation.Error'
              )
            ),
            error
          ),
      }
    );
  };

  if (isPending) {
    return (
      <Flex alignItems="center" justifyContent="center">
        <Loading
          text={t('Page.StorageUnit.Actions.Terminate.Reservation.Loading')}
        />
      </Flex>
    );
  }

  if (error) {
    return <Error message="Error.TerminateAllocation" />;
  }

  return (
    <Flex flexDirection="column" alignItems="center" gap="5rem">
      <Heading
        variant="h2"
        title={t('Page.StorageUnit.Actions.Terminate.Reservation.Heading')}
      />
      {formNotice && (
        <Notification
          testId="terminate-reservation-notification"
          message={formNotice}
        />
      )}
      <Button
        testId="terminate-reservation-confirm-button"
        variant="danger"
        size="l"
        title={t('Page.StorageUnit.Actions.Terminate.Reservation')}
        onClick={handleTerminateAllocation}
      />
    </Flex>
  );
};

export default TerminateReservation;
